import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=658b2566&scoped=true"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"
import style0 from "./Scroller.vue?vue&type=style&index=0&id=658b2566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b2566",
  null
  
)

export default component.exports